// extracted by mini-css-extract-plugin
export default {"dialogBody":"RemoveDialog_dialogBody__8S+rg","dialogBodyMultiParagraph":"RemoveDialog_dialogBodyMultiParagraph__ty0ge","dialogMultiButton":"RemoveDialog_dialogMultiButton__qcFjN"};